import { action } from 'mobx';
export var setActiveScreen = action(function (store, screen) {
    window.scrollTo(0, 0);
    if (store.activeScreen !== screen) {
        // store.clearAvailableLists();
    }
    store.activeScreen = screen;
});
